import { useTranslation } from "react-i18next";
import ErrorNotice from "../../../../errors/ErrorNotice";
import { useSubmission } from "../../../../shared/state/useSubmission";
import ToggleSwitch from "../../../../ui/forms/ToggleSwitch";
import { changeThreadSettings } from "../../data/settingsChanges";
import { useThreadContext } from "../threadPageContext";
import { actionDecision, actionOffer, asDecision } from "../viewerActions";

/**
 * "Stop before agent steps" (O4 of the workflow design proposal, section 0.8; built provisionally, awaiting
 * Johannes's answer): while it is on, an agent step that would start by itself waits for Run, with what it will
 * send open to review (F148). It is one of the Run's settings, which module C lets the host change; a Workflow not
 * yet proven starts its Runs with it on. Shown only where the viewer is offered the change.
 */
export default function StopBeforeAgentSteps() {
  const { t } = useTranslation();
  const { threadId, overview } = useThreadContext();
  const { state, submit } = useSubmission();
  if (actionOffer(overview.viewer, "change_settings") === null) return null;
  const label = t("threads.steps.stopBeforeAgentSteps");
  return (
    <span className="flex items-center gap-1.5 text-xs">
      <ToggleSwitch
        checked={overview.settings.stop_before_agent_steps === true}
        label={label}
        disabled={state.status === "submitting"}
        requires={asDecision(actionDecision(overview.viewer, "change_settings"), overview.projectId)}
        onChange={(stops) => {
          submit(() => changeThreadSettings(threadId, overview.lastEntryNumber, { ...overview.settings, stop_before_agent_steps: stops }, overview.bindings));
        }}
      />
      <span aria-hidden="true">{label}</span>
      {state.status === "failed" ? <ErrorNotice error={state.error} compact={true} /> : null}
    </span>
  );
}
